import axios from "@/utils/request";

export const webShareGetAward = (data) => {
  return axios.post(`/activity/webShareGetAward`, data);
};
export const webShareCheckAuth = (password) => {
  return axios.post(`/activity/webShareCheckAuth`, { password });
};
